import { Container } from "./containers/Container";
import { RDisplay } from "./RotDisplay";
import { ComponentO, createElement } from "./ui";

export abstract class Scene {
  abstract ui: ComponentO;

  update(display: RDisplay, elapsed: number) {
    return;
  }

  render(rotDisplay: RDisplay) {
    this.ui(rotDisplay);
  }

  destroy() {
    //empty
  }
  create() {
    //empty
  }
}

class EmptyScene extends Scene {
  ui = createElement(Container, { x: 0, y: 0, w: 0, h: 0 });
}

let currentScene: Scene = new EmptyScene();

export function setScene(scene: Scene) {
  currentScene.destroy();
  currentScene = scene;
  currentScene.create();
}

export function getScene() {
  return currentScene;
}
